import React from "react";
import { buildWhatsAppLink } from "../lib/api";

export default function WhatsAppFAB() {
  return (
    <a
      href={buildWhatsAppLink("Hi I'm Ube team, I'd like wholesale pricing for bulk Ube powder.")}
      target="_blank"
      rel="noreferrer"
      style={{ position: "fixed", bottom: "1.5rem", right: "1.5rem", zIndex: 60 }}
      className="wa-pulse"
      aria-label="Chat on WhatsApp"
      data-testid="whatsapp-fab"
    >
      <div className="h-14 w-14 md:h-16 md:w-16 rounded-full bg-[#25D366] hover:bg-[#1ebe5d] transition-colors flex items-center justify-center shadow-2xl">
        <svg viewBox="0 0 24 24" className="h-7 w-7 md:h-8 md:w-8 text-white" fill="currentColor" aria-hidden="true">
          <path d="M20.52 3.48A11.93 11.93 0 0 0 12.06 0C5.5 0 .15 5.34.15 11.9c0 2.1.55 4.15 1.6 5.96L0 24l6.31-1.66a11.9 11.9 0 0 0 5.75 1.47h.01c6.56 0 11.91-5.34 11.91-11.9 0-3.18-1.24-6.17-3.46-8.43Zm-8.46 18.3h-.01a9.9 9.9 0 0 1-5.05-1.38l-.36-.21-3.74.98 1-3.64-.24-.37a9.9 9.9 0 0 1-1.52-5.28c0-5.46 4.45-9.9 9.93-9.9 2.65 0 5.14 1.03 7.02 2.91a9.83 9.83 0 0 1 2.9 7c0 5.47-4.45 9.9-9.93 9.9Zm5.43-7.42c-.3-.15-1.76-.87-2.04-.97-.27-.1-.47-.15-.66.15-.2.3-.76.97-.93 1.17-.17.2-.34.22-.64.07-.3-.15-1.26-.46-2.4-1.48-.88-.79-1.48-1.76-1.65-2.06-.17-.3-.02-.46.13-.61.13-.13.3-.34.45-.51.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.66-1.6-.91-2.19-.24-.57-.49-.49-.66-.5l-.56-.01c-.2 0-.52.07-.8.37-.27.3-1.05 1.02-1.05 2.49 0 1.47 1.08 2.89 1.23 3.09.15.2 2.12 3.24 5.13 4.55.72.31 1.28.49 1.71.63.72.23 1.37.2 1.88.12.57-.08 1.76-.72 2.01-1.41.25-.69.25-1.28.17-1.4-.07-.13-.27-.2-.57-.35Z"/>
        </svg>
      </div>
    </a>
  );
}
